import React from "react";
import SectionHeading from "@/components/common/SectionHeading";
import Icon from "@/components/common/Icon";
import { Stagger, StaggerItem } from "@/components/common/Reveal";
import { whyChoose } from "@/config/site";

export default function WhyChoose({ chapter = "06" }) {
  return (
    <section className="container-page py-20 lg:py-28" data-testid="why-choose-section">
      <SectionHeading
        chapter={chapter}
        eyebrow="Why work with us"
        title="A more organized way to manage cross-border requirements"
        intro="Practical coordination built around your requirement — without superiority claims or guarantees."
      />
      <Stagger className="mt-12 grid gap-px bg-[#D9E0E4] sm:grid-cols-2 lg:grid-cols-3 border border-[#D9E0E4] rounded-lg overflow-hidden">
        {whyChoose.map((w) => (
          <StaggerItem key={w.title}>
            <div className="h-full bg-white p-7">
              <div className="flex items-center gap-3">
                <Icon name={w.icon} className="h-5 w-5 text-teal" />
                <span className="h-px flex-1 bg-[#D9E0E4]" />
              </div>
              <h3 className="mt-5 font-heading font-bold text-[17px] text-navy">{w.title}</h3>
              <p className="mt-2 text-[14.5px] leading-relaxed text-muted-foreground">{w.copy}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
